import type { TranslationMessages } from './types';

export const common: TranslationMessages = {
  all: 'Tất cả',
  actions: 'Hành động',
  search: 'Tìm kiếm',
  add: 'Thêm',
  close: 'Đóng',
  cancel: 'Hủy',
  accessDenied: 'Truy cập bị từ chối',
  page: 'Trang',
  of: 'của',
  total: 'tổng cộng',
  groups: 'nhóm',
  total_items: 'tổng số mục',
  noPermissionCostManagement: 'Bạn không có quyền xem quản lý chi phí.',
  noPermissionCostCategoryManagement:
    'Bạn không có quyền xem quản lý danh mục chi phí.',
  actionsObj: {
    cancel: 'Đóng',
    save: 'Lưu',
    edit: 'Chỉnh sửa',
    delete: 'Xóa',
    create: 'Tạo',
    update: 'Cập nhật',
    filter: 'Lọc',
    clear: 'Xóa',
    all: 'Tất cả',
    loading: 'Đang tải...',
  },
  filters: 'Bộ lọc',
  filter: 'Lọc',
  create: 'Tạo',
  update: 'Cập nhật',
  delete: 'Xóa',
  save: 'Lưu',
  saving: 'Đang lưu...',
  none: 'Không',
};
